import * as React from "react";
function SvgFb(props) {
  return (
    <svg
      viewBox="0 0 8 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.951 8.132v7.61c0 .146.147.146.147.146h2.78c.146 0 .146-.147.146-.147V7.985h2.05c.146 0 .146-.146.146-.146l.146-2.341c0-.147-.146-.147-.146-.147H5.024v-1.61c0-.439.293-.731.732-.731h1.61c.146 0 .146-.147.146-.147V.376c0-.147-.146-.147-.146-.147H4.732c-1.61 0-2.78 1.317-2.78 2.78v2.196H.633c-.146 0-.146 0-.146.146v2.342c0 .146.146.146.146.146h1.317v.293z"
        fill="#fff"
      />
    </svg>
  );
}
export default SvgFb;
